import axios from "axios";
import { API_BASE_CMS,API_BASE_IMG_URl } from "helper/environment";


export const getContactBannerByUid = async (uid: string) => {
  const API_URL = `${API_BASE_CMS}/jsonapi/block_content/contact_banner_and_quick_connect/${uid}?include=field_bg_img,field_bg_img.field_media_image`;

  const res = await axios.get(API_URL);

  const block = res.data.data;
  const included = res.data.included || [];

  return {
    title: block.attributes.info || "",
    bgImage: (() => {
      const mediaRel = block.relationships.field_bg_img?.data;
      const media = included.find(
        (item: any) =>
          item.type === "media--image" && item.id === mediaRel?.id
      );

      const fileRel = media?.relationships?.field_media_image?.data;
      const file = included.find(
        (item: any) =>
          item.type === "file--file" && item.id === fileRel?.id
      );

      return file?.attributes?.uri?.url
        ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
        : "";
    })(),
  };
};

//For Quick connect 
/**
 * Fetch Quick Connect block
 */
export const getContactQuickConnectByUid = async (uid: string) => {
  const res = await axios.get(
    `${API_BASE_CMS}/jsonapi/block_content/contact_banner_and_quick_connect/${uid}`,
    {
      params: {
         include: "field_quick_connect_part,field_contact_form_field",
      },
    }
  );

  const { data, included = [] } = res.data;

  const quickConnectHeader =
    data.attributes.body?.value || "";
    const formTitle = data.attributes.field_form_title || "";
    const mainTitle = data.attributes.field_title.value || "";
    const subTitle = data.attributes.field_sub_title || "";
    const formbutton = data.attributes.field_form_button || "";
  const items =
    data.relationships.field_quick_connect_part?.data.map(
      (ref: any) => {
        const para = included.find(
          (i: any) =>
            i.type === "paragraph--contact_icon_and_description" &&
            i.id === ref.id
        );
 
        return {
          text: para?.attributes?.field_descriptions?.value || "",
          iconClass: para?.attributes?.field_button_link || "",
        };
      }
    ) || [];
    const formfield =
    data.relationships.field_contact_form_field?.data.map(
      (ref: any) => {
        const para = included.find(
          (i: any) =>
            i.type === "paragraph--contact_form_field" &&
            i.id === ref.id
        );
 
        return {
          name: para?.attributes?.field_field_name || "",
          value: para?.attributes?.field_field_value || "",
          placeholder: para?.attributes?.field_placeholder || "",
        };
      }
    ) || [];

  return {
    quickConnectHeader,formTitle,mainTitle,subTitle,formbutton,
    items,formfield
  };
};
//quick connect ends